module.exports = __webpack_public_path__ + "img/gift.2aad90cf.svg";